import {
    ChangeDetectorRef,
    Component,
    OnInit,
    Inject,
    AfterViewInit,
    ViewChild,
    ElementRef
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import {JobViewService} from "@app/features/customers/customer/jobs-view/service/job-view-service";
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@app/utils/get-api-url';

// import { TemplatesConfigService } from '@app/features/system-settings/general-custom-templates-config/services/templates-config.service';
import { SystemSettingsService } from '@app/services';

declare var $: any;

@Component({
    selector: 'app-change-part-status-modal',
    templateUrl: './change-part-status.modal.html',
    styleUrls: ['./change-part-status.modal.scss']
})
// tslint:disable-next-line:component-class-suffix
export class ChangePartStatusModal implements OnInit, AfterViewInit {
    items = [];
    title: string ;
    label: string;
    closeBtnName: string = 'Cancel';
    jobId: number;
    activeTab: string;
    form: FormGroup;
    action: string = '';
    status: string;
    saveLabel: string;
    moduleId: number;
    jobToDos: any;

    formModel = {
        partName: '',
        quantity: null
    };

    select2Config: any;
    selectedPartId: any;
    selectedRows: any;
    selectedRowsMarkAS: any;
    onClose = new Subject();
    @ViewChild('saveBtn') saveBtn: ElementRef;

    constructor(
        private formBuilder: FormBuilder,
        @Inject('$scope') private ajsScope,
        // private httpService: TemplatesConfigService,
        public bsModalRef: BsModalRef,
        private changeDetector: ChangeDetectorRef,
        private systemSettingsService: SystemSettingsService,
        private jobService: JobViewService
    ) {}

    ngOnInit() {
        this.items = this.selectedRowsMarkAS.map(part => ({
            id: part.id,
            name: part.Part,
            qty: parseInt(part.Quantity),
            maxqty: parseInt(part.Quantity)
        }));
        this.onClose = new Subject();

        this.form = this.formBuilder.group({
            partName: [this.formModel.partName, Validators.required],
            quantity: [this.formModel.quantity, [Validators.required, Validators.min(1)]]
        });

        this.initSelect2Config();
    }

    initSelect2Config() {
        this.select2Config = {
            multiple: false,
            width: '100%',
            placeholder: 'Select a part kit',
            allowClear: true,
            ajax: {
                url: `${environment.apiBasePath}searchPartKits`,
                data: (searchText, page) => {
                    if (!searchText) return false;
                    return { searchText };
                },
                results: (data) => {
                    return { results: data.partKits || [] };
                }
            }
        };
    }

    ngAfterViewInit() {

    }



    increment(item: any): void {
        if (item.qty < item.maxqty) {
            item.qty++;
        }
    }

    decrement(item: any): void {
        if (item.qty > 0) {
            item.qty--;
        }
    }

    isFormValid(): boolean {
        // must have at least one item > 0
        const hasValidQty = this.items.some(i => i.qty > 0);
        const hasInvalidQty = this.items.some(i => i.qty > i.maxqty || i.qty < 0 || i.qty === '');
        return hasValidQty && !hasInvalidQty;
    }

    close(): void {
        // logic to close modal
    }

    markAsReturn(): void {
        const selectedItems = this.items
            .filter(item => item.qty > 0)
            .map(item => ({
                id: item.id,
                allocatedQuantity: item.qty,
                totalQuantity: item.maxqty
            }));
        // logic to submit returned items
        let formData = new FormData();
        formData.append('partsData', JSON.stringify(selectedItems));
        formData.append('moduleId', String(this.moduleId));
        formData.append('jobtodos', String(this.jobToDos));
        this.jobService.job_part_batch_status_update(this.jobId, this.activeTab, this.status, formData).subscribe({
            next: res => {
                this.onClose.next(res);
            },
            error: err => {
                console.error('Error:', err.errorMessage);
                this.onClose.next(err);
            }
        });
    }

    blockNonNumbers(event: KeyboardEvent) {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    }

    onQtyInput(item: any, event: any) {
        let value = event.target.value;
        value = value.replace(/[^0-9]/g, '');
        if (value === '') {
            item.qty = 0;
            event.target.value = 0;
            return;
        }
        let num = Number(value);
        // Restrict max
        if (num > item.maxqty) {
            num = item.maxqty;
        }
        item.qty = num;
        // Force update UI
        event.target.value = num;
    }

    fixQty(item: any) {
        if (item.qty === '' || item.qty === null || isNaN(item.qty)) {
            item.qty = 0;
            return;
        }

        if (item.qty < 0) item.qty = 0;
        if (item.qty > item.maxqty) item.qty = item.maxqty;
    }



}
